import React, { useState } from 'react'

import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import Avatar from '@mui/material/Avatar'
import ClickAwayListener from '@mui/material/ClickAwayListener'

import './TopBar.scss'

import { useCMSContext } from '../CMSContext'
import CustomMenuHeader from '../../Shared/MainMenu/MainMenuHeader'
import ProfileMenuHeader from '../../Shared/MainMenu/ProfileMenuHeader'
import defaultSubscriberLogo from '../Content/DepartmentInfo/department-logo.jpg'
import TimeWrapper from './timeWrapper'

const TopBar = () => {
  const cmsContext = useCMSContext()
  const { fireDepartment, iarMember } = cmsContext.state
  const [isActive, setIsActive] = useState(false)
  const [isProfileActive, setIsProfileActive] = useState(false)

  const handleMenu = () => {
    setIsActive(!isActive)
  }

  const handleMenuClickAway = () => {
    if (isActive) {
      setIsActive(false)
    }
  }

  const handleProfileMenu = () => {
    setIsProfileActive(!isProfileActive)
  }

  const handleProfileClickAway = () => {
    if (isProfileActive) {
      setIsProfileActive(false)
    }
  }

  return (
    <div>
      <AppBar className="TopBar MuiAppBar-colorPrimary" position="static">
        <Toolbar>
          <ClickAwayListener onClickAway={handleMenuClickAway}>
            <IconButton
              className="MuiIconButton-root"
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleMenu}
            >
              <MenuIcon />
            </IconButton>
          </ClickAwayListener>
          <CustomMenuHeader isMenuActive={isActive} />

          <div className="iarLogoContainer">
            <picture>
              <source
                className="iarLogo"
                srcSet={`${window._env_.COMMUNITY_LOGOS_URL}/IarCommunity_logo.avif`}
                type="image/avif"
                alt="IAR Logo"
              />
              <source
                className="iarLogo"
                srcSet={`${window._env_.COMMUNITY_LOGOS_URL}/IarCommunity_logo.webp`}
                type="image/webp"
                alt="IAR Logo"
              />
              <img
                className="iarLogo"
                src={`${window._env_.COMMUNITY_LOGOS_URL}/IarCommunity_logo.png`}
                alt="IAR Logo"
              />
            </picture>
          </div>
          <div className="subscriberLogo">
            <img
              className="subscriberLogo"
              src={
                fireDepartment && fireDepartment.logo ? fireDepartment.logo : defaultSubscriberLogo
              }
              alt="IAR Logo"
            />
          </div>
          <div className="agencyName">
            {fireDepartment ? fireDepartment.fireDepartmentName : ''}
          </div>
          <TimeWrapper />

          {iarMember?.profileImage ? (
            <Avatar
              className="iar-avatar"
              src={iarMember.profileImage}
              alt="profile"
              onClick={handleProfileMenu}
            ></Avatar>
          ) : (
            <div className="iar-avatar" onClick={handleProfileMenu}>
              <span>
                {`${iarMember?.fullName?.[0] ?? ''}${iarMember?.fullName?.split?.(' ')?.[1]?.[0] ?? ''}`}
              </span>
            </div>
          )}

          <ProfileMenuHeader
            isMenuProfileActive={isProfileActive}
            Member={iarMember}
            handleProfileClickAway={handleProfileClickAway}
            setIsProfileActive={setIsProfileActive}
          />
        </Toolbar>
      </AppBar>
    </div>
  )
}

export default TopBar
